import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import MuiTable from "../MuiTable/MuiTable";
import Button from "@material-ui/core/Button";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import "./JobsCart.css";
const JobsCart = ({ disableInitial }) => {
  useEffect(() => {
    disableInitial(false);
  }, []);
  const marks = [
    {
      value: 0,
      label: "",
    },
    {
      value: 30,
      label: "",
    },
    {
      value: 67,
      label: "",
    },
    {
      value: 100,
      label: "",
    },
  ];
  const columns = [
    "Job Title",
    "Class",
    "Curriculum",
    "Experience",
    "Salary offered",
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const mainkey = tableMeta.rowData[5];

          return (
            <div className="actions-cart">
              <Button variant="outlined" className="save-btn">
                save for later
              </Button>
              <div
                className="delete-icon"
                style={{
                  display: "flex",
                  backgroundColor: "grey !important",
                  // marginRight: '10px',
                }}
                // onClick={() => deleteDocument(tableMeta.rowData[0])}
              ></div>
            </div>
          );
        },
      },
    },
  ];
  const columns2 = [
    "Job Title",
    "Class",
    "Curriculum",
    "Experience",
    "Salary offered",
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const mainkey = tableMeta.rowData[5];

          return (
            <div className="actions-cart">
              <Button variant="outlined" className="save-btn">
                Add to cart
              </Button>
              <div
                className="delete-icon"
                style={{
                  display: "flex",
                  backgroundColor: "grey !important",
                  // marginRight: '10px',
                }}
                // onClick={() => deleteDocument(tableMeta.rowData[0])}
              ></div>
            </div>
          );
        },
      },
    },
  ];
  const data = [
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
  ];
  const data2 = [
    ["PTR Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["PTR Maths teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
  ];

  // added by Uzhairkhan
  const search = useLocation().search;
  const id = new URLSearchParams(search).get("id");
  // added by Uzhairkhan
  return (
    <div>
      <header className="jpdm-routes">
        <Link to={`/institute/job/createjobpost?id=${id}`}>
          Create Job Post
        </Link>
        <span>{">"}</span>
        <p>Cart</p>
      </header>
      <div className="job-cart-container">
        <div className="title-job">
          <span className="job-title-text">4 Posts in the cart</span>
          <div className="add-new-job">
            <button className="add-btn">+</button>
            <span className="add-new-job-text">Add new Job</span>
          </div>
        </div>
        <div className="job-post-table">
          <MuiTable columns={columns} data={data} />
        </div>
        <div className="post-line-at-top"></div>
        <div className="post-title">Post Cart</div>
        <div className="post-card">
          <div className="post-card-head-it1">
            Posts created <div className="post-card-info" />
          </div>
          <div className="post-card-head-it2">
            Total posts selected <div className="post-card-info" />
          </div>
          <div className="post-card-head-it3">
            Discount applied <div className="post-card-info" />
          </div>

          <div className="post-card-head-values1">04</div>
          <div className="post-card-head-values2">06</div>
          <div className="post-card-head-values3">15%</div>
          <div className="post-card-slider">
            <Slider
              aria-label="Custom marks"
              defaultValue={30}
              getAriaValueText={valuetext}
              step={1}
              valueLabelDisplay="auto"
              marks={marks}
            />
          </div>
          <div className="job-post-slider-mark1" />
          <div className="job-post-slider-mark2" />
          <div className="job-post-slider-mark3" />
        </div>
        <div className="drafted-jobs">
          <div className="drafted-job-title">Drafted Jobs</div>
          <MuiTable columns={columns2} data={data2} />
        </div>
        <div className="order-summary">
          <div className="order-summary-title">Order summary</div>
          <div className="order-summary-line"></div>
          <div className="order-summary-list1">
            <div className="order-list-item">Price per post</div>
            <div className="order-list-price">₹26,500</div>
          </div>
          <div className="order-summary-list2">
            <div className="order-list-item"> Number of posts</div>
            <div className="order-list-price">06</div>
          </div>
          <div className="order-summary-list3">
            <div className="order-list-item">Discount</div>
            <div className="order-list-price">₹2,650</div>
          </div>
          <div className="dotted-line"></div>
          <div className="order-summary-list4">
            <div className="list-name">
              <div className="discount">
                <div className="order-list-item">Discount</div>
                <span className="list-percent">15%</span>
              </div>
              <div className="gst">(Incl GST)</div>
            </div>
            <div className="order-list-price">₹2,650</div>
          </div>
          <div className="gst-input">
            <TextField
              id="outlined-multiline-flexible"
              label="Gst"
              multiline
              maxRows={5}
              defaultValue={"GSTIN12345"}
              //   onChange={handleChange}
              className="order-gst-inp"
            />
          </div>
          <div className="checkout">
            <Button
              variant="contained"
              className="checkout-btn"
              style={{ color: "white" }}
            >
              checkout
            </Button>
          </div>
          <div className="payment-banner"></div>
        </div>
      </div>
    </div>
  );
  function valuetext(value) {
    return `${value}°C`;
  }
};

export default JobsCart;
